import {rgba} from "polished";
import {ReactElement} from "react";
import {styled} from "styled-components";

import {Button} from "@/components/Button/Button";
import {quicksandSemiBold} from "@/GlobalStyle";

const ErrorBloc = styled.aside``;
const ErrorContent = styled.div`
  display: flex;
  max-width: 100%;
  width: 100%;
  @include quicksand-semiBold();
  font-size: 1.181rem;
  text-align: center;
  margin-bottom: 20px;
  color: ${({theme}) => theme.colors.alert};
  background-color: ${({theme}) => rgba(theme.colors.alert, 0.1)};
`;
const ErrorImage = styled.img`
  flex: 1;
  width: inherit;
  margin: 20px 0 20px 10px;
`;

const ErrorTextButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 2;
  padding: 10px;
  gap: 15px;
  flex-wrap: wrap;
  & p {
    ${quicksandSemiBold}
    text-align: center;
    flex: 1;
    min-width: 60%;
    font-size: 1rem;
  }
`;

export function ErrorMessage({
  image,
  text,
  buttonToRefresh = false,
  onRetry,
}: {
  image?: string;
  text?: string | null;
  variant?: "red" | "orange" | "bleu";
  buttonToRefresh?: boolean;
  onRetry?: () => Promise<void>;
}): ReactElement {
  const handleReload = async (): Promise<void> => {
    if (onRetry) {
      await onRetry();
    } else {
      window.location.href = "/";
    }
  };
  const illustration = image ? (
    <ErrorImage src={image} alt="Icon d'erreur" data-testid="ErrorImage" />
  ) : null;
  return (
    <ErrorBloc data-testid="ErrorBloc">
      <ErrorContent data-testid="ErrorContent" id="error-content">
        {illustration}
        <ErrorTextButton data-testid="ErrorTextButton">
          <p>{text}</p>
          {buttonToRefresh ? (
            <Button
              label={onRetry ? "Réessayer" : "Revenir à l'accueil"}
              onClick={async (e: React.MouseEvent<HTMLButtonElement>) => {
                e.preventDefault();
                e.stopPropagation();
                await handleReload();
              }}
              variant="secondary"
            />
          ) : null}
        </ErrorTextButton>
      </ErrorContent>
    </ErrorBloc>
  );
}
